import React, { useContext, useEffect, useMemo, useState } from "react";
import { Badge, Box, Button, Paper, Tooltip, Typography } from "@mui/material";
import issue from "../../../../assets/svg/noProduct.svg";
import Catalogues from "./Catalogues";
import DataTableComponent from "../../../../components/common/DataTable/DataTable";
import { generateProductListColumns } from "../../helper";
import SimpleBar from "simplebar-react";
import StoreStepperContext from "../../../../context/storeStepperContext";
import ConfirmationModal from "../../../../components/common/ConfirmationModal/ConfirmationModal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

function AddProductButton({ data }) {
  const navigate = useNavigate();
  const {
    storeformData,
    setStoreFormData,
    saveContinueBtn,
    setSaveContinueBtn,
    checkForEdit,
    setCheckForEdit,
    productIdForEdit,
    setProductIdForEdit,
    setAddProductFromOverview,
    setProductCatalog,
  } = useContext(StoreStepperContext);
  const user = useSelector((state) => state.auth.value);

  const [confirmatioModalState, setConfirmationModalState] = useState({
    showModal: false,
    productId: "",
  });
  const [showPorduct, setShowProduct] = useState(false);

  const cancelHandler = () => {
    setConfirmationModalState({ showModal: false, productId: "" });
  };

  const deleteHandler = async () => {
    try {
      const updatedProducts = storeformData.products.filter(
        (product) => product.productId !== confirmatioModalState.productId
      );

      setStoreFormData((prev) => ({
        ...prev,
        products: updatedProducts,
      }));

      toast.success("Product deleted successfully!");
      setConfirmationModalState({ showModal: false, productId: "" });
    } catch (error) {
      console.error("Error removing product:", error);
      toast.error("Failed to remove product. Please try again.");
    }
  };

  const menuOptions = useMemo(
    () => [
      {
        id: "edit",
        iconName: "mdi:square-edit-outline",
        actionName: "Edit",
        onClickHandle: (row) => {
          setCheckForEdit(true);
          setProductIdForEdit(row?.productId);
          navigate("/shopping/store/add-product", {
            state: { id: row?.productId },
          });
        },
      },
      {
        id: "delete",
        iconName: "material-symbols:delete-rounded",
        actionName: "Request For Delete",
        isDisable: false,
        onClickHandle: (row) => {
          setConfirmationModalState((prev) => ({
            showModal: true,
            productId: row?.productId,
          }));
        },
      },
    ],
    []
  );

  const variantColumns = generateProductListColumns(menuOptions);

  useEffect(() => {
    if (saveContinueBtn === true && storeformData?.products?.length > 0) {
      setShowProduct(true);
    }
  }, [saveContinueBtn, storeformData?.products?.length]);

  return (
    <>
      <SimpleBar
        forceVisible="x"
        autoHide={true}
        style={{
          overflowX: "auto",
          maxHeight: "calc(100vh - 310px)",
          minHeight: "calc(100vh - 310px)",
        }}
        className="custom-scrollbar"
      >
        {showPorduct && checkForEdit === false ? (
          <>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginBottom: "6px",
                width: "50%",
                margin: "0 auto",
                paddingBottom: "20px",
                backgroundColor: "white",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  gap: "10px",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography variant="h4">Product List</Typography>

                <Tooltip
                  title={
                    <span
                      style={{
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <span
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "6px",
                          alignItems: "center",
                        }}
                      >
                        <Badge
                          // color="primary"
                          variant="dot"
                          mr={1}
                          sx={{
                            "& .MuiBadge-badge": {
                              color: "lightgreen",
                              backgroundColor: "blue",
                            },
                          }}
                        />{" "}
                        Parcel Product{" "}
                      </span>
                    </span>
                  }
                  arrow
                  placement="bottom"
                >
                  <ErrorOutlineIcon />
                </Tooltip>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  width: "500px",
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#5E17EB",
                    color: "#fff",
                    border: "1px solid #E5E5E8",
                    borderRadius: "4px",
                    boxShadow: "none",
                    whiteSpace: "nowrap",
                    fontWeight: 600,
                    "&:hover": {
                      outline: "none",
                      color: "#fff",
                      backgroundColor: "#5E17EB",
                    },
                  }}
                  onClick={() => {
                    sessionStorage.setItem("stepperRedirectStep", "1");
                    navigate("/shopping/store/add-product");
                    setCheckForEdit(false);
                    setProductIdForEdit("");
                    setAddProductFromOverview(false);
                    setProductCatalog(false);
                    setStoreFormData((prev) => ({
                      ...prev,
                      currentProduct: {
                        productId: "",
                        productName: "",
                        productCategory: "",
                        productBrand: "",
                        productPrice: "",
                        productWeight: "",
                        productStock: "",
                        productDimentionL: "",
                        productDimentionW: "",
                        productDimentionH: "",
                        productDescription: "",
                        productTags: [],
                        productImage: [],
                        productVarient: [],
                        productStatus:
                          user?.role === "Superadmin" ? true : false,
                        productUnderReview: false,
                      },
                    }));
                  }}
                >
                  Add Product
                </Button>
              </Box>
            </Box>
            <div>
              {storeformData?.products?.length > 0 && (
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  <Paper
                    sx={{
                      width: "50%",
                      border: "1px solid #E5E5E8",
                      borderRadius: "4px",
                    }}
                  >
                    <DataTableComponent
                      data={storeformData?.products || []}
                      columns={variantColumns}
                      customStyles={{
                        table: {
                          style: {
                            borderCollapse: "collapse",
                          },
                        },
                        headCells: {
                          style: {
                            borderRight: "1px solid rgba(229, 229, 232, 1)",
                          },
                        },
                        cells: {
                          style: {
                            borderRight: "1px solid rgba(229, 229, 232, 1)",
                          },
                        },
                      }}
                    />
                  </Paper>
                </Box>
              )}
              {storeformData?.products &&
                storeformData?.products?.length <= 0 && (
                  <Box sx={{ marginTop: "10%" }}>
                    <Box sx={{ display: "flex", justifyContent: "center" }}>
                      <img src={issue} alt="issue_not_found" />
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        marginTop: "30px",
                      }}
                    >
                      <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                        No records found
                      </Typography>
                    </Box>
                  </Box>
                )}
            </div>
          </>
        ) : (
          <Box
            sx={{
              // display: "flex",
              justifyContent: "center",
              width: "50%",
              margin: "auto auto",
              marginTop: "10vh",
            }}
          >
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <img src={issue} alt="issue_not_found" />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "30px",
              }}
            >
              <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                No records found
              </Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "14px",
              }}
            >
              <Button
                variant="contained"
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  backgroundColor: "#5E17EB",
                  color: "#fff",
                  border: "1px solid #E5E5E8",
                  borderRadius: "4px",
                  boxShadow: "none",
                  whiteSpace: "nowrap",
                  fontWeight: 600,
                  "&:hover": {
                    outline: "none",
                    color: "#fff",
                    backgroundColor: "#5E17EB",
                  },
                }}
                onClick={() => {
                  sessionStorage.setItem("stepperRedirectStep", "1");
                  navigate("/shopping/store/add-product");
                  setCheckForEdit(false);
                  setProductIdForEdit("");
                  setAddProductFromOverview(false);
                  setProductCatalog(false);
                  setStoreFormData((prev) => ({
                    ...prev,
                    currentProduct: {
                      productId: "",
                      productName: "",
                      productCategory: "",
                      productBrand: "",
                      productPrice: "",
                      productWeight: "",
                      productStock: "",
                      productDimentionL: "",
                      productDimentionW: "",
                      productDimentionH: "",
                      productDescription: "",
                      productTags: [],
                      productImage: [],
                      productVarient: [],
                      productStatus: user?.role === "Superadmin" ? true : false,
                      productUnderReview: false,
                    },
                  }));
                }}
              >
                Add Product
              </Button>
            </Box>
          </Box>
        )}
        <ConfirmationModal
          showModal={confirmatioModalState.showModal}
          submitHandler={() => deleteHandler()}
          submitText={"Delete"}
          cancelText={"Cancel"}
          cancelHandler={cancelHandler}
          headerText={"Are you sure?"}
          bodyText={"You want to delete this product"}
        />
      </SimpleBar>
    </>
  );
}

export default AddProductButton;
